import { createSlice } from '@reduxjs/toolkit';
import { fetchBillingSystems } from 'common/services/api/BillingSystems/BillingSystems.thunk';
import { BillingSystems } from 'common/types/Entities';
import { createLoadedExtraReducers } from 'common/utils/sliceUtils/entitySliceUtils';
import { filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

import type { RootState } from '../../app/store';

type BillingSystemsState = FilterState & {
    billingSystems: BillingSystems[],
    loaded: boolean,
};

const initialState: BillingSystemsState = {
    billingSystems: [],
    loaded: false,
    filters: {
        keywords: [],
    },
};

const billingSystemsSlice = createSlice({
    name: 'billingSystems',
    initialState,
    reducers: () => ({
        ...filterReducers,
    }),

    extraReducers: builder => {
        createLoadedExtraReducers<BillingSystems>(builder, fetchBillingSystems, 'billingSystems');
    }
});

// eslint-disable-next-line no-restricted-syntax
export default billingSystemsSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = billingSystemsSlice.actions;
export const selectFilters = (state: RootState) => state.billingSystems.filters;
export const selectBillingSystems = (state: RootState) => state.billingSystems.billingSystems;
export const selectBillingSystemsLoadedStatus = (state: RootState) => state.billingSystems.loaded;
